<h2 mat-dialog-title>
  <mat-icon> bookmark </mat-icon>
  {{ data.type == 'create' ? 'Equipo nuevo' : 'Edición de equipo' }}
</h2>
<mat-dialog-content class="mat-typography">

  <form [formGroup]="formGroup">
    <!-- Equipo del catálogo nuevo (TORRE 1…), solo los del hospital elegido -->
    <app-auto-select label="Equipo (del hospital)" formControlName="equipment" [options]="equipmentList" [labelFn]="equipmentLabelFn"></app-auto-select>

    <mat-form-field appearance="outline">
      <mat-label>Número de serie</mat-label>
      <input matInput formControlName="serialNumber"/>
      <mat-error>Número de serie de equipo es <strong>requerido</strong></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Año de fabricación</mat-label>
      <input matInput formControlName="manufacturerYear"/>
      <mat-error>Año de fabricación de equipo es <strong>requerido</strong></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Lote</mat-label>
      <input matInput formControlName="batch"/>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Tipo de propiedad</mat-label>
      <mat-select formControlName="ownershipType">
        <mat-option [value]="null">—</mat-option>
        @for (opt of ownershipOptions; track opt.id) {
          <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Ubicación (alias)</mat-label>
      <mat-select formControlName="location">
        <mat-option [value]="null">—</mat-option>
        @for (place of placeList; track place.id) {
          <mat-option [value]="place.id">{{ place.alias ? place.alias + ' — ' + place.name : place.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Responsable en ubicación</mat-label>
      <input matInput formControlName="locationResponsible"/>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Núm./código de garantía</mat-label>
      <input matInput formControlName="warrantyNumber"/>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Inicio de garantía</mat-label>
      <input matInput [matDatepicker]="pickerStart" formControlName="warrantyStart"/>
      <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Fin de garantía</mat-label>
      <input matInput [matDatepicker]="pickerEnd" formControlName="warrantyEnd" [min]="formGroup.value['warrantyStart']"/>
      <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Etiqueta RFID (24 caracteres)</mat-label>
      <input matInput type="text" maxlength="24" placeholder="24 caracteres" formControlName="tagRfid"/>
      <mat-hint align="end">{{ (formGroup.controls['tagRfid'].value || '').length }}/24</mat-hint>
      <mat-error>{{ formGroup.controls['tagRfid'].hasError('required') ? 'Etiqueta RFID de equipo es requerida' : 'La etiqueta debe tener 24 caracteres' }}</mat-error>
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancelar</button>
  @if (data.type == 'create') {
    <button mat-raised-button color="primary" (click)="create()">Guardar</button>
  }
  @if (data.type == 'update') {
    <button mat-raised-button color="primary" (click)="update()">Guardar</button>
  }
</mat-dialog-actions>
